import InnerComponent from '@Components/Purchase/PurchaseIndent/PurchaseIndentForm';
import orgContainer from '@Components/AppContainer';

const UpdatePurchaseIndent = () => ((orgContainer(InnerComponent)));
export default UpdatePurchaseIndent;